import { Link } from "react-router-dom"
import { useUser } from "../utils/UserProvider"

const ProfileAvatar = () => {
  const { user, loading } = useUser()
  const userData = user?.data?.config?.user

  return (
    <Link to={"/app"} className="w-full bg-background flex flex-col items-center space-x-4 p-2 rounded-xl gap-3">
      <img
        src={userData?.photoUrl || "https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg"}
        alt="Profile"
        className="w-16 h-16 rounded-full"
      />
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-medium leading-3 text-center text-textPrimary">
          {!loading ? (
            userData?.name
          ) : (
            "Loading..."
          )}
        </h2>
        <p className="text-sm leading-3 text-textSubHeading">
          {!loading ? (
            userData?.email
          ) : (
            "Loading..."
          )}
        </p>
      </div>
    </Link>
  )
}

export default ProfileAvatar
